import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { MbUpdateinfoReq } from 'app/bff/models/mb/mbUpdateinfo';
import { ProcessStepCodesEnum } from 'app/features/Member/Register/Permission/types';
import { FormValues as ClausesFormValues } from 'app/features/Member/Register/Permission/Clauses/types';
import { FormValues as ConfirmInfoFormValues } from 'app/features/Member/Register/Permission/ConfirmInfo/types';
import { PermissionState, PermissionActions, MEMBER_REGISTER_PERMISSION__SET_ACCESSIBLE_STEP, MEMBER_REGISTER_PERMISSION__SAVE_CLAUSES_PAGE_DATA, MEMBER_REGISTER_PERMISSION__SAVE_CONFIRM_INFO_PAGE_DATA, MEMBER_REGISTER_PERMISSION__SEND_OTP, MEMBER_REGISTER_PERMISSION__SEND_OTP_DONE, MEMBER_REGISTER_PERMISSION__RESEND_OTP, MEMBER_REGISTER_PERMISSION__RESEND_OTP_DONE, MEMBER_REGISTER_PERMISSION__AUTH_OTP, MEMBER_REGISTER_PERMISSION__SEND_REGISTER_DATA, MEMBER_REGISTER_PERMISSION__UPDATE_CACHE, MEMBER_REGISTER_PERMISSION__RESET_CACHE } from './types';

/**
 * @description 設置可訪問步驟 (Action)
 * @param step 當前步驟
 */
export const setAccessibleStepAction = (step: ProcessStepCodesEnum): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__SET_ACCESSIBLE_STEP,
  payload: { step }
});

/**
 * @description 緩存「同意相關告知事項」(Step-1) 頁面資料 (Action)
 * @param data 頁面資料
 */
export const saveClausesPageDataAction = (data: ClausesFormValues): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__SAVE_CLAUSES_PAGE_DATA,
  payload: { data }
});

/**
 * @description 緩存「確認資料」(Step-2-1) 頁面資料 (Action)
 * @param data 頁面資料
 */
export const saveConfirmInfoPageDataAction = (data: ConfirmInfoFormValues): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__SAVE_CONFIRM_INFO_PAGE_DATA,
  payload: { data }
});

/**
 * @description 發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const sendOTPAction = (args: AaOtpSendcodeReq): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__SEND_OTP,
  payload: { args }
});

/**
 * @description 發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const sendOTPDoneAction = (response: AaOtpSendcodeResp): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__SEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 重新發送 OTP 驗證碼 (Action)
 * @param args 請求所需的參數
 */
export const resendOTPAction = (args: AaOtpSendcodeReq): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__RESEND_OTP,
  payload: { args }
});

/**
 * @description 重新發送 OTP 驗證碼 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const resendOTPDoneAction = (response: AaOtpSendcodeResp): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__RESEND_OTP_DONE,
  payload: { response }
});

/**
 * @description 驗證 OTP 驗證碼 (Action)
 * @param authOTPArgs 驗證 OTP 驗證碼，請求所需的參數
 * @param registerArgs 註冊會員 (更新會員資料)，請求所需的參數
 */
export const authOTPAction = (authOTPArgs: AaOtpVerifyReq, registerArgs: MbUpdateinfoReq): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__AUTH_OTP,
  payload: { authOTPArgs, registerArgs }
});

/**
 * @description 送出會員資料執行註冊 (Action)
 * @param args 請求所需的參數
 */
export const sendRegisterDataAction = (args: MbUpdateinfoReq): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__SEND_REGISTER_DATA,
  payload: { args }
});

/**
 * @description 更新資料緩存 (Action)
 * @param cache 緩存資料
 */
export const updateCacheAction = (cache: PermissionState): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__UPDATE_CACHE,
  payload: { cache }
});

/**
 * @description 重置資料緩存 (Action)
 */
export const resetCacheAction = (): PermissionActions => ({
  type: MEMBER_REGISTER_PERMISSION__RESET_CACHE
});
